<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Reporte de Saldos</h3>
      </div>
      <div class="layout__controls">
        <div class="form-inline">
          <button type="button" @click="imprimirExcel" id="excel" class="btn-success">
            <i class="fa fa-file-excel-o" aria-hidden="true"></i><span>Excel</span>
          </button>
          <button type="button" @click="consultar" id="consultar" class="btn-info btn--bigger">
            <i class="fa fa-search" aria-hidden="true"></i><span>Consultar</span>
          </button>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12 col-md-6">
            <div class="form-group select2">
              <div class="select2-field select2-field--stretch">
                <v-select multiple v-model="rutasSeleccionadas" id="rutas" placeholder="Todas..." :options="rutas"
                  label="descripcion">
                </v-select>
                <label for="rutas">Rutas</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-inline form-inline--stretch">

              <div class="form-inline__title">
                Fecha
              </div>
              <div class="form-inline__content">
                <label>
                  <input v-model="form.tipo_fecha" type="radio" value="H" />
                  <span>Hoy</span>
                </label>
                <label>
                  <input v-model="form.tipo_fecha" type="radio" value="A" />
                  <span>Ayer</span>
                </label>
                <label>
                  <input v-model="form.tipo_fecha" type="radio" value="P" />
                  <span>Personalizado</span>
                </label>
                <div class="d-flex gap-3" v-show="form.tipo_fecha == 'P'">
                  <div class="form-field">
                    <div class="datepicker-field datepicker-field--stretch">
                      <VueCtkDateTimePicker id="desde" v-model="form.fecha_desde" locale="es" no-label only-date
                        auto-close button-now-translation="Ahora" format="YYYY-MM-DD" formatted="YYYY-MM-DD"
                        label="Seleccione fecha..." />
                      <label>Desde</label>
                    </div>
                  </div>
                  <div class="form-field">
                    <div class="datepicker-field datepicker-field--stretch">
                      <VueCtkDateTimePicker id="hasta" v-model="form.fecha_hasta" locale="es" no-label only-date
                        auto-close button-now-translation="Ahora" format="YYYY-MM-DD" formatted="YYYY-MM-DD"
                        label="Seleccione fecha..." />
                      <label>Hasta</label>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12">
            <vue-good-table :columns="columns" :pagination-options="{
            enabled: true,
            perPage: 20,
            perPageDropdown: [],
            nextLabel: 'siguiente',
            prevLabel: 'anterior',
            rowsPerPageLabel: 'Registros por página',
            ofLabel: 'de',
            allLabel: 'Todo',
            dropdownAllowAll: true
          }" :rows="registros" :search-options="{
            enabled: true,
            placeholder: 'Buscar...'
          }" styleClass="vgt-table vgt-table--sticky">
              <template slot="table-row" slot-scope="props">
                <span v-if="!columnsNoNumeric.includes(props.column.field)">
                  {{ moneyFormat(props.formattedRow[props.column.field]) }}
                </span>
              </template>
            </vue-good-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    rutas: {
      required: false,
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data: function () {
    return {
      moneyFormat: moneyFormat,
      registros: [],
      rutasSeleccionadas: [],
      form: {
        tipo_consulta: 'C',
        tipo_fecha: 'H',
        fecha_desde: moment(new Date()).format('YYYY-MM-DD'),
        fecha_hasta: moment(new Date()).format('YYYY-MM-DD'),
        idsRutas: []
      },
      columnsNoNumeric : ['fecha', 'ruta_nombre'],
      columns: [
        {
          label: 'Fecha',
          field: 'fecha'
        },
        {
          label: 'Ruta',
          field: 'ruta_nombre'
        },
        {
          label: 'Saldo',
          field: 'saldo'
        },
        {
          label: 'Sobrante',
          field: 'sobrante'
        },
        {
          label: 'Debería',
          field: 'deberia'
        },
        {
          label: 'Programados',
          field: 'deberia_agendados'
        },
        {
          label: 'Microseguro',
          field: 'total_microseguro'
        }
      ]
    }
  },
  watch: {
    'form.fecha_desde': function (value) {
      if (value != null && value != undefined) {
        if (value.length == 10) {
          let date = new Date(value);
          if (date == 'Invalid Date') {
            swal('Error', 'La fecha inicial es incorrecta', 'error');
            this.form.fecha_desde = null;
          }
        }
      }
    },
    'form.fecha_hasta': function (value) {
      if (value != null && value != undefined) {
        if (value.length == 10) {
          let date = new Date(value);
          if (date == 'Invalid Date') {
            swal('Error', 'La fecha final es incorrecta', 'error');
            this.form.fecha_hasta = null;
          }
        }
      }
    },
    rutasSeleccionadas: function () {
      this.form.idsRutas.splice(0, this.form.idsRutas.length);
      for (let i = 0; i < this.rutasSeleccionadas.length; i++) {
        this.form.idsRutas.push(this.rutasSeleccionadas[i].id);
      }
    }
  },
  methods: {
    consultar: function () {
      if (this.validarFiltros()) {
        let that = this;
        let urlApi = url + '/reporte-caja/consultar-saldo-ruta';
        this.form.tipo_consulta = 'C';
        axios.get(urlApi, {
          params: this.form
        }).then(function ({ data }) {
          that.registros = data.rutasCobros.map(ruta => {
            return ruta;
          });
        }).catch(function (error) {
          swal('Error', 'No se pudo consultar los registros, intente nuevamente', 'error');
        });
      }
    },
    imprimirExcel: function () {
      if (this.validarFiltros()) {
        this.form.tipo_consulta = 'E';
        let queryString = this.serialize(this.form);
        let urlApi = url + '/reporte-caja/consultar-saldo-ruta' + queryString;
        window.open(urlApi, '_blank');
      }
    },
    serialize: function (obj) {
      return (
        "?" +
        Object.keys(obj)
          .reduce(function (a, k) {
            let val = obj[k];
            let esArray = false;
            if (val instanceof Date) {
              val = val.toLocaleDateString("en");
            } else if (val instanceof Array) {
              esArray = true;
              let acumulador = "";
              for (let i = 0; i < val.length; i++) {
                acumulador += k + "%5B%5D=" + val[i];
                if (i != val.length - 1) {
                  acumulador += "&";
                }
              }
              val = acumulador;
              a.push(val);
            }
            if (!esArray) a.push(k + "=" + encodeURIComponent(val));
            return a;
          }, [])
          .join("&")
      );
    },
    validarFiltros: function () {
      if (this.form.tipo_fecha == 'P') {
        if (this.form.fecha_desde == null || this.form.fecha_hasta == null) {
          swal('Aviso', 'Debe ingresar las fechas', 'warning');
          return false;
        }
        else if (this.form.fecha_desde.length != 10 || this.form.fecha_hasta.length != 10) {
          swal('Aviso', 'Debe ingresar las fechas de manera correcta', 'warning');
          return false;
        }
      }
      return true;
    },
  },
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/reportes/SaldoRuta.vue